export default function isBlank(string) {
  return typeof string === 'undefined' || string === null || string.length === 0 || string.trim() === '';
}
